export default "__VITE_ASSET__$9ejk0c___"